:host {
  display: block;
}

:host([list-item-style='bullet']) {
  display: list-item;
  list-style-position: outside;
  margin-left: 18px;
}

:host([list-item-style='supercard-bullet']) {
  display: list-item;
  padding-inline-start: 25px;
  list-style: none;
  position: relative;

  &::before {
    content: '\e814';
    font-family: var(--primary-icon-font);
    font-size: 8px;
    line-height: 1;
    background-color: var(--color-blue);
    color: var(--color-white);
    border-radius: 50%;
    display: inline-block;
    padding: 3px;
    position: absolute;
    top: 2px;
    left: 0;
  }
}

:host(.t-space-30) {
  margin-top: 1.875rem;
}

:host(.letter-spacing-1) {
  letter-spacing: 1px;
}

:host(.mt-16) {
  margin-top: 16px;
}

:host(.mt-32) {
  margin-top: 32px;
}

:host(.mb-10) {
  margin-bottom: 0.625rem;
}

:host(.mb-15) {
  margin-bottom: 0.9375rem;
}

:host(.mb-32) {
  margin-bottom: 32px;
}

:host(.mb-40) {
  margin-bottom: 40px;
}

:host(.force-ellipsis) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  .force-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

:host(.inline) {
  display: inline;
  p {
    display: inline;
  }
}

::slotted(img) {
  height: 2em; // twice the font-size
  aspect-ratio: 1;
  vertical-align: middle;
  padding: 0 4px;
  object-fit: cover;
}

.reset {
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
  color: inherit !important;
}

.p {
  margin: 0;
  padding: 0;
  font-family: var(--primary-font);
  font-weight: var(--font-weight-normal);
  font-style: var(--font-weight-normal);
  color: var(--color-nero);

  &.line-height-2 {
    line-height: 2;
  }
  &.line-height-37 {
    line-height: 37px;
  }
  &.line-height-12 {
    line-height: 12px;
  }
  &.line-height-24 {
    line-height: 24px;
  }
  &.regular-plus {
    font-weight: var(--font-weight-medium);
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.two-lines {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: unset;
  }
}

.hero {
  font-size: 18px;
  line-height: 27px;
}

.icon-text {
  display: flex;
  align-items: baseline;

  &.align-right {
    justify-content: flex-end;
  }
}

.uppercase {
  text-transform: uppercase;
}

.underline {
  text-decoration: underline;
}

.align-center {
  text-align: center;
}

lilu-icon {
  margin-right: 9px;
}

@include supportedColors();
@include supportedTypography();

::slotted(a) {
  text-decoration: underline;
  text-transform: uppercase;
}

::slotted(.normalcaseLink) {
  text-transform: none;
}

::slotted(.semibold) {
  font-weight: var(--font-weight-semibold);
}

::slotted(lilu-link) {
  display: inline-block;
}
